export const FACT_FIND_TYPE = {
  GENERAL: 'General',
  INVITE: 'Invite',
  REQUEST: 'Request',
  REVIEW: 'Review',
};
